import { forkJoin, from, Observable, Observer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { ReadFile } from './read-file.model';

@Injectable()
export class ApFileReaderService {
    public readFilesParallel(files: File[]): Observable<ReadFile> {
        return from(files).pipe(mergeMap((file: File) => this.readFile(file, new FileReader())));
    }

    public readFilesAsArray(files: File[]): Observable<ReadFile[]> {
        return forkJoin(files.map((file: File) => this.readFile(file, new FileReader())));
    }

    public readFile(file: File, reader: FileReader): Observable<ReadFile> {
        return new Observable((observer: Observer<ReadFile>) => {
            reader.onload = () => {
                const readFile = file as ReadFile;
                readFile.contents = reader.result;
                observer.next(readFile);
                observer.complete();
            };

            reader.onerror = () => {
                observer.error('Failed uploading file');
                observer.complete();
            };

            reader.readAsDataURL(file);
        });
    }
}
